import { Component, HostListener, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ThemeService } from '@app/services/theme.service';
import { Subject, Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',

  imports: [TranslocoModule, CommonModule, RouterModule]
})
export class FooterComponent implements OnInit, OnDestroy {
  @Input() tournamentFooter: boolean = false;
  private themeService = inject(ThemeService);

  themeSub !: Subscription;
  destroy$ = new Subject<void>();
  darkMode: boolean = false;
  screenWidth: number = 0;
  isRotated: { [key: string]: boolean } = {
    'links': false,
    'about': false
  }
  content: { [key: string]: boolean } = {
    'links': false,
    'about': false
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;

    this.themeService.isDarkMode$.pipe(takeUntil(this.destroy$)).subscribe({
      next: response => {
        this.darkMode = response;
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.screenWidth = event.target.innerWidth;
  }

  showContent(value: string) {

    const isCurrentlyOpen = this.content[value];

    Object.keys(this.content).forEach(key => {
      this.content[key] = false;
      this.isRotated[key] = false;
    });

    if (!isCurrentlyOpen) {
      this.content[value] = true;
      this.isRotated[value] = true;
    }
  }

}
